
const BASE_URL = process.env.REACT_APP_API_BASE_URL;

export const getAllChannelPartners = async (page = 1, itemsPerPage = 10) => {
  try {
    const token = localStorage.getItem("authToken");
    const response = await fetch(
      `${BASE_URL}/eci/apis/v4/wallets/get_anchor_wallets?page=${page}&items=${itemsPerPage}`, 
      {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );

    if (!response.ok) {
      throw new Error("Failed to fetch channel partners");
    }

    const data = await response.json();
    return {
      items: data.msg?.items || [],
      pagination: data.msg?.pagination || {}
    };
  } catch (error) {
    console.error("Error fetching channel partners:", error);
    throw error;
  }
};

export const getTpaWallet = async (page = 1, itemsPerPage = 10) => {
  try {
    const token = localStorage.getItem("authToken");
    const anchorId= localStorage.getItem("anchorId")
    const response = await fetch(
      `${BASE_URL}/eci/apis/v4/wallets/get_tpa_wallet?page=${page}&items=${itemsPerPage}&anchor_id=${anchorId}`, 
      {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );

    if (!response.ok) {
      throw new Error("Failed to fetch channel partners");
    }

    const data = await response.json();
    return {
      items: data.msg?.items || [],
      pagination: data.msg?.pagination || {}
    };
  } catch (error) {
    console.error("Error fetching channel partners:", error);
    throw error;
  }
};
